import React, { useEffect, useState } from "react";
import { useAuth } from "../../../auth/AuthContext";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useNavigate, useParams } from "react-router";
import Loader from "../../shared/Loader";
import ClientOrderInfoView from "./ClientOrderInfoView";
import UnauthorizedUserModal from "../../shared/UnauthorizedUserModal";
import { orderService } from "../../../services/orderService";
import { ClientOrdersListItemDTO } from "../../../models/order/order.response";
import { handleErrorNotification } from "../../../utils/errorNotificatioMessage";
import { OrderStatusType, orderStatusTypeToClassName, orderStatusTypeToString } from "../../../models/base/OrderStatusType";
import { OrderType } from "../../../models/base/OrderType";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import { ClocckGreyIcon, CloseGreyIcon } from "../../../assets/icons";
import { AnimatePresence, motion } from "framer-motion";
import { connection, startConnection } from "../../../services/signalRConnection";
interface ClientOrdersViewProps {
    localName: string;
    onClose: () => void;
}

const ClientOrdersView: React.FC<ClientOrdersViewProps> = ({ onClose, localName }) => {

    const [isClientOrderInfoViewOpen, setIsClientOrderInfoViewOpen] = useState(false);
    const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);

    const [orders, setOrders] = useState<ClientOrdersListItemDTO[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const { user } = useAuth();

    const localId = useParams().localId;

    const { notify } = useNotification();


    useEffect(() => {
        fetchOrders();
    }, [user, localId]);

    useEffect(() => {

        const handler = (orderId: string, status: OrderStatusType) => {
            setOrders(prev => prev.map(order => order.id === orderId ? { ...order, currentStatus: status } : order))
        }

        const setup = async () => {
            await startConnection();
            connection.on("OrderStatusChange", handler);
        }

        setup();

        return () => {
            connection.off("OrderStatusChange", handler);
        };

    }, [localId]);



    const fetchOrders = async () => {
        if (!user || !user.id) {
            notify("error", "Korisnik nije prijavljen");
            return;
        }

        if (!localId) {
            notify("error", "ID lokala nije prosleđen");
            return;
        }

        setLoading(true);
        try {
            const response = await orderService.getUsersOrdersInLocal(user.id, localId);

            if (response.success && response.data) {
                setOrders(response.data);
            } else {
                notify("error", "Greška pri učitavanju porudžbina", response.message || "Došlo je do greške pri učitavanju porudžbina.");
            }
        } catch (error: any) {
            notify("error", "Greška pri učitavanju porudžbina", "Došlo je do greške pri učitavanju porudžbina.");
            handleErrorNotification(error, notify);
        } finally {
            setLoading(false);
        }
    };

    const orderHtmlInfo = (order: ClientOrdersListItemDTO) => {
        switch (order.type) {
            case OrderType.DineIn:
                return (
                    <div className="description-text">Sto {order.tableNumber} • {ToLocalDateTimeString(order.createdAt.toString())}</div>
                )
            case OrderType.Pickup:
                return (
                    <div className="description-text">Preuzimanje • {ToLocalDateTimeString(order.pickUpAt.toString())}</div>
                )
            case OrderType.Delivery:
                return (
                    <div className="description-text">Dostava • {order.street}, {order.streetNumber}{order.apartment ? `/${order.apartment}` : ""}</div>
                )
        }
    };



    if (!user || !user.id) {
        return <UnauthorizedUserModal
            onClose={onClose}
        />;
    }

    return (
        <>
            <AnimatePresence>
                {isClientOrderInfoViewOpen && selectedOrderId &&
                    <ClientOrderInfoView
                        onClose={() => setIsClientOrderInfoViewOpen(false)}
                        orderId={selectedOrderId}
                    />
                }
            </AnimatePresence>

            <section className="modal-section client-orders" onClick={onClose}>
                <div className="w-layout-blockcontainer container w-container">
                    <motion.section
                        initial={{ opacity: 0, scale: 0.96, y: 12 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.96, y: 12 }}
                        transition={{ duration: 0.2 }}
                    >
                        <div className="modal-wrapper">
                            <div className="modal-div" onClick={(e) => e.stopPropagation()}>
                                <div className="modal-header-div">
                                    <div>
                                        <div className="modal-header">
                                            Praćenje porudžbina
                                        </div>
                                    </div>
                                    <div className="modal-button-div" onClick={onClose}>
                                        <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" />
                                    </div>
                                </div>
                                <div className="modal-main-div">
                                    <div>Moje porudžbine u lokalu "<strong>{localName}</strong>" u zadnjih 14 dana</div>
                                    <div className="client-modal-orders-list">

                                        {orders
                                            .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                                            .map((order) => (
                                                <div className="client-modal-order-div" key={order.id} onClick={() => { setIsClientOrderInfoViewOpen(true); setSelectedOrderId(order.id); }}>
                                                    <div className="client-modal-order-header-div">
                                                        <div className="text-block-18">
                                                            Porudžbina #{order.id.slice(0, 8)}
                                                        </div>
                                                        <div className={`small-box-div order-status ${orderStatusTypeToClassName(order.currentStatus)}`}>
                                                            <div>{orderStatusTypeToString(order.currentStatus)}</div>
                                                        </div>
                                                    </div>
                                                    {orderHtmlInfo(order)}
                                                    <div className="client-modal-order-bottom-div">
                                                        <div className="description-text">{order.itemCount} stavka</div>
                                                        <div className="client-product-price-div">{order.totalPrice} RSD</div>
                                                    </div>
                                                </div>
                                            ))}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.section>
                </div>
            </section>
        </>
    );

};

export default ClientOrdersView;